import React, { useState } from 'react';
import { withNamespaces } from 'react-i18next';
import { observer } from 'mobx-react';
import { parse } from 'date-fns';
import Alert from 'react-s-alert';
import { Button, Input } from 'components';
import { VoxelDialog } from '@wikifactory/voxel-ui';
import { isNaN } from 'lodash';

export const ExtendFreeTrialButton = withNamespaces()(
  observer(({ extendFreeTrial, loading }: any) => {
    const [open, setOpen] = useState(false);
    const [value, setValue] = useState('');

    return (
      <>
        <Button
          variant='tertiary'
          outline
          size='small'
          text='Extend Free Trial Period'
          onClick={() => {
            setOpen(true);
          }}
        />

        <VoxelDialog
          actions={
            <div className='flex justify-end mt-2 w-full px-4'>
              <Button
                variant='primary'
                outline
                size='small'
                loading={loading}
                text='Extend'
                onClick={() => {
                  try {
                    const parsedDate = parse(value, 'dd/MM/yyyy', new Date());
                    if (parsedDate.toString() === 'Invalid Date') {
                      throw new Error(
                        'Invalid date, please input in DD/MM/YYYY format',
                      );
                    }
                    const timestamp = Math.floor(parsedDate.getTime() / 1000);
                    if (isNaN(timestamp)) {
                      throw new Error('Invalid date');
                    }

                    extendFreeTrial(timestamp, () => {
                      setOpen(false);
                    });
                  } catch (e) {
                    Alert.error(e?.message);
                  }
                }}
              />
            </div>
          }
          open={open}
          onClose={() => {
            setOpen(false);
          }}
          onBackdropClick={() => {
            setOpen(false);
          }}
        >
          <h3>Input Trial End Date:</h3>
          <Input
            width={400}
            className='mt-2'
            placeholder='DD/MM/YYYY'
            onChange={e => {
              setValue(e.target.value);
            }}
            value={value}
          />
        </VoxelDialog>
      </>
    );
  }),
);
